
















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { MeasurementsClient } from "@/data/web-api-client";
import notificationService from "@/services/notificationService";
import PdfViewer from "@/plugins/pdfjs/PdfViewer.vue";

@Component({
  components: {
    PdfViewer
  }
})
export default class MeasurementDocument extends Vue {
  @Prop({ required: true })
  private projectId!: string;
  @Prop({ required: true })
  private documentNumber!: string;
  private documentUrl: string = "";
  private loading: boolean = false;
  private height: number = 500;
  private created() {
    let height = window.innerHeight - 400;
    if (height < 500) {
      height = 500;
    }
    this.height = height;
    this.loadDocument();
  }

  async loadDocument() {
    try {
      this.loading = true;
      const data = await new MeasurementsClient(
        undefined,
        this.$axios
      ).getDocument(this.projectId, this.documentNumber.replaceAll("/", "-"));

      this.documentUrl = URL.createObjectURL(data.data);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }
}
